import { getEmployersDetail, getEmployerDetail, getAllJobs, createEmployer, logActivity, getEmployerReport, doCsvUploadForEmployer } from '../api'

export const loadEmployerReport = ({ state, commit }) => {
  return getEmployerReport().then(data => {
    commit('LOAD_REPORT', data)
    return data
  })
}

export const loadLogActivity = ({ state, commit }, {data}) => {
  return logActivity(data)
}

export const loadCreateEmployer = ({ state, commit }, {employer}) => {
  return createEmployer(employer)
}

export const uploadEmployerCsvFile = ({ state, commit }, fileData) => {
  return doCsvUploadForEmployer(fileData).then(res => {
    return res
  })
}

export const loadEmployersDetail = ({ state, commit }, institutionId) => {
  return getEmployersDetail(institutionId).then(data => {
    if (data !== undefined) {
      commit('LOAD_EMPLOYERS', data)
    }
    return data
  })
}

export const loadEmployerDetail = ({ state, commit }, uuid) => {
  return getEmployerDetail(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_EMPLOYER', data)
    }
    return data
  })
}

export const loadAllJobs = ({ state, commit }, uuid) => {
  return getAllJobs(uuid).then(data => {
    if (data !== undefined) {
      commit('LOAD_CATEGORIES', data)
    }
    return data
  })
}



// WEBPACK FOOTER //
// ./src/app/employer/vuex/actions.js